import React from "react";
import Modal from "../../../shared/components/Modal/Modal";
import "../../../components/tests/Dashboard/PracticeDashboard.css";

const PracticeSublistModal = ({
  isOpen,
  onClose,
  selectedItemName,
  selectedSublist,
  onSubitemClick,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width="auto"
    height="auto"
    backgroundColor="#fff"
    closeAboveModal
    marginTop="0"
  >
    <div className="modal-item-content">
      {selectedItemName ? (
        <h3 className="modal-title" id="modal-title-left">
          {selectedItemName}
        </h3>
      ) : null}

      {selectedSublist?.sublist?.map((subitem, index) => (
        <div
          key={`${subitem.id}-${index}`}
          className="modal-item"
          onClick={() => onSubitemClick(subitem)}
          style={{ cursor: "pointer" }}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              onSubitemClick(subitem);
            }
          }}
        >
          <div className="modal-item-header">
            <div className="modal-icon-container">
              <img
                src={subitem?.image}
                alt={subitem?.sublistName}
                className="modal-icon"
              />
            </div>

            <div className="modal-item-details">
              <p className="modal-item-name" style={{ marginBottom: "0px" }}>
                {subitem?.sublistName}
              </p>
              {subitem?.description ? (
                <p className="modal-item-description">{subitem.description}</p>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  </Modal>
);

export default PracticeSublistModal;
